import { welcomeMessage } from '../../utils/chatConstants';

export const clearCommand = (setMessages) => {
    setMessages([welcomeMessage]);
    return true;
}; 